import {FormGroup, FormControl, FormArray} from '@angular/forms';
import {DateTime} from 'luxon';
import {WebbillCostSpecifications} from './models/webbill-cost-specification.model';
import {OnlineCostSpecifications} from '@reporting/costs/models/specification.model';

export type CostSpecificationControl = FormGroup<{
    lineAmountDeviationWarning: FormControl<boolean>;
    amount: FormControl<number | null>;
    description: FormControl<string>;
    vat: FormControl<string | null>;
    consumptionUnit: FormControl<string | null>;
    consumptionAmount: FormControl<number | null>;
    consumptionCost: FormControl<boolean>;
    calculatedByBrunata: FormControl<boolean>;
    deleted: FormControl<boolean>;
    consumptionAmountDeviationWarning: FormControl<boolean>;
    webBillCostSpecification: FormControl<WebbillCostSpecifications | null>;
    onlineCostSpecification: FormControl<OnlineCostSpecifications | null>;
}>;

export type GroupControl = FormGroup<{
    costSpecifications: FormArray<CostSpecificationControl>;
    costGroupId: FormControl<string | null>;
    webBillCostGroupId: FormControl<string | null>;
    rowVersion: FormControl<string | null>;
    groupName: FormControl<string | null>;
    groupNo: FormControl<number | null>;
    enabled: FormControl<boolean>;
}>;

export type CostDocControl = FormGroup<{
    buildingNo: FormControl<string | null>;
    costReceivedDate: FormControl<DateTime | null>;
    refunds: FormControl<string | null>;
    noteToBrunata: FormControl<string | null>;
    billMessageFromCustomer: FormControl<string | null>;
    billMessageRefund: FormControl<string | null>;
    billMessageOutstanding: FormControl<string | null>;
    contactPerson: FormControl<string | null>;
    contactEmail: FormControl<string | null>;
    contactPhoneNo: FormControl<string | null>;
    groups: FormArray<GroupControl>;
    costState: FormControl<string | null>;
    residentListAccepted: FormControl<boolean>;
    requestResidentList: FormControl<boolean>;
}>;

export type AccountPeriodControl = FormGroup<{
    startDate: FormControl<DateTime | null>;
    endDate: FormControl<DateTime | null>;
}>;

type CostSpecificationValues = {
    consumptionCost: boolean;
    calculatedByBrunata: boolean;
    deleted: boolean;
};

export function updateFormGroupControls(
    costSpecificationFormGroup: CostSpecificationControl,
    {consumptionCost, calculatedByBrunata, deleted}: CostSpecificationValues,
): void {
    if (deleted === false) {
        costSpecificationFormGroup.enable({emitEvent: false});
        if (calculatedByBrunata) {
            costSpecificationFormGroup.disable({emitEvent: false});
        } else if (consumptionCost) {
            costSpecificationFormGroup.controls.amount.enable({emitEvent: false});
            costSpecificationFormGroup.controls.vat.enable({emitEvent: false});
            costSpecificationFormGroup.controls.consumptionUnit.enable({emitEvent: false});
            costSpecificationFormGroup.controls.consumptionAmount.enable({emitEvent: false});
        } else {
            costSpecificationFormGroup.controls.vat.enable({emitEvent: false});
            costSpecificationFormGroup.controls.amount.enable({emitEvent: false});
            costSpecificationFormGroup.controls.consumptionUnit.disable({emitEvent: false});
            costSpecificationFormGroup.controls.consumptionAmount.disable({emitEvent: false});
        }
    } else {
        costSpecificationFormGroup.disable({emitEvent: false});
    }

    costSpecificationFormGroup.updateValueAndValidity();
}
